/* src/app/components/lead-details/summary/lead-detail-summary/lead-detail-summary.component.css */
.chart-container {
  width: 500px;
  height: 500px;
}
.chart-box {
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.ppl-form-item {
  width: 100% !important;
}
.filter-title {
  font-size: 1.714rem;
  font-weight: 600;
  color: #01796F;
  margin-bottom: 1rem;
  text-align: bottom;
}
.view-welcome-letter,
.download-welcome-letter {
  width: 100px;
  color: white !important;
}
.view-welcome-letter:focus-visible,
.download-welcome-letter:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
}
.button-container {
  display: flex;
  justify-content: space-evenly;
}
.summary-heading {
  background-color: #bebdf575;
  padding: 4px;
  border-radius: 4px;
  font-size: 1.286rem;
  margin-bottom: 10px;
  margin-top: 0;
  font-weight: 500;
}
.completed-count {
  font-size: 1.5rem !important;
}
.highlight {
  color: #1890ff;
  cursor: pointer;
}
li.nostyle {
  list-style-type: none;
}
.tile-container {
  text-align: left;
  font-size: 16px;
  overflow-y: auto;
}
.wide-card {
  grid-column: span 3;
  justify-content: flex-start;
  max-height: 400px;
}
@media (max-width: 768px) {
  .wide-card {
    grid-column: unset;
  }
}
.high-util {
  color: #ff0000;
}
.medium-util {
  color: #f08030;
}
.low-util {
  color: #01796f;
}
.red {
  color: #ff0000;
  font-weight: 600;
}
/*# sourceMappingURL=lead-detail-summary.component-I6OPNE7N.css.map */
